import axios, { AxiosPromise } from 'axios';
import { IUserToken } from '../../../@types/model/auth/userToken/userToken';
import { ILogInView } from '../../../@types/model/auth/logIn/LogInView';
import { IGoogleLogInView } from '../../../@types/model/auth/logIn/GoogleLogInView';
import { ISignUpView } from '../../../@types/model/auth/logIn/SignUpView';
import { ILocationDetail } from '../../../@types/model/auth/logIn/locationDetail';

export default class AuthHttpService {

    public static getLoginLocationDetail = () : AxiosPromise<ILocationDetail> => {
        return axios.get('https://api.seeip.org/geoip');
    }

    public static signUp = (signUpView : ISignUpView) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/Authorisation/SignUp`, signUpView);
    };

    public static logInManual = (logInView : ILogInView) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/Authorisation/LogIn`, logInView);
    }

    public static googleLogIn = (googleLogInView : IGoogleLogInView) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/Authorisation/LogInGoogle`, googleLogInView);
    }

    public static getSession = () : AxiosPromise<IUserToken> => {
        return axios.get(`${API_URL}/v1/Authorisation/GetSession`);
    }

    public static logout = () : AxiosPromise => {
        return axios.get(`${API_URL}/v1/Authorisation/Logout`);
    }

    public static logoutUsers = (userIds : Array<number>) : AxiosPromise => {
        return axios.post(`${API_URL}/v1/Authorisation/LogoutUsers`, userIds);
    }

    public static requestForgottenPasswordEmail(emailOrEmpNumber : string) : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/Right/User/RequestForgottenPasswordEmail`, null, {
            params: {
                emailOrEmpNumber 
            }
        });
    }

    public static resetPassword(recoveryCode : string, email : string, newPassword : string) : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/Right/User/ResetPassword`, {
            recoveryCode,
            newPassword,
            email,
        });
    }
}
